import { useStyletron, H4, Text3, Button } from '@olxeu-jobs/ui';
import type { FallbackProps } from 'react-error-boundary';
import { FormattedMessage } from '~i18n';
import { FallOfTheIceCream } from '~ui/illustrations';

export const Fallback: React.FC<Pick<FallbackProps, 'resetErrorBoundary'>> = ({
  resetErrorBoundary,
}) => {
  const [css, theme] = useStyletron();

  return (
    <div
      className={css({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100vw',
        // 48px is mobile navbar height
        height: 'calc(100vh - 48px)',
        [theme.mediaQuery.md]: {
          width: 'auto',
          height: 'auto',
        },
      })}
    >
      <FallOfTheIceCream />
      <H4 $as="h3" $style={{ marginBottom: theme.space[16] }}>
        <FormattedMessage id="comp.error.generic.title" defaultMessage="Something went wrong" />
      </H4>
      <Text3
        $style={{
          marginBottom: theme.space[6],
          color: theme.colors['text-global-secondary'],
        }}
      >
        <FormattedMessage
          id="comp.error.generic.body"
          defaultMessage="Refresh this page or go back to the homepage."
        />
      </Text3>
      <Button kind="tertiary" onClick={resetErrorBoundary}>
        <FormattedMessage id="comp.error.generic.refresh" defaultMessage="Refresh" />
      </Button>
    </div>
  );
};
